import React from 'react';
import {t} from '@lingui/core/macro';

import cn from 'classnames';

import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';

import {isTranslate} from '../../../shared/lib/lang';

import styles from './Error.module.scss';

const Error: React.FC = () => {
    return (
        <BlankLayout pageTitle={t`Сервис не доступен`}>
            <div className={cn(
                styles.wrapper,
                isTranslate() ? styles.enColor : styles.ruColor,
            )}>
                <h1>{t`Сервис временно недоступен`}</h1>
                <p>{t`Мы проводим технические работы на сервере`}.</p>
                <p>{t`Пожалуйста, вернитесь позже`}.</p>
                <p>{t`Спасибо за ваше понимание`}!</p>
            </div>
        </BlankLayout>
    );
};

export default Error;